import React, {FC, RefObject} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {useContactDetailsContext} from '../contactDetailsContext';
import {ContactNotesHandle} from './contactNotes';

/*
 * Props.
 */

interface ContactNoteAddNoteButtonProps {
  notesRef?: RefObject<ContactNotesHandle | undefined>;
}

/*
 * Style.
 */

const StyledAddNoteButtonContainerDiv = styled.div`
  display: flex;
`;

const StyledAddNoteButton = styled(Button)`
  margin: -4px -12px -4px 0;
`;

/*
 * Component.
 */

export const ContactNoteAddNoteButton: FC<ContactNoteAddNoteButtonProps> = (props) => {
  const {notesRef} = props;
  const {isReadOnly} = useContactDetailsContext();

  if (isReadOnly) {
    return null;
  }

  return (
    <StyledAddNoteButtonContainerDiv>
      <StyledAddNoteButton
        variant={ButtonVariantsEnum.LINK}
        onClick={() => {
          if (notesRef?.current) {
            notesRef?.current.onAddNote();
          }
        }}
        interactionId="contact-details-add-note-button"
      >
        <Trans id="contact-details-notes-add-note-button">+ Add</Trans>
      </StyledAddNoteButton>
    </StyledAddNoteButtonContainerDiv>
  );
};
